__webpack_require__.p = "/ducks-in-half-circle/";